import { LinkButton } from '@finn-no/troika-react-buttons';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styles';
import isDesktop from './isDesktop';

const FeedbackFace = (props) => {
    const { nr, text, onClick, disabled } = props;

    const cdn = (rating) => {
        return `https://static.finncdn.no/_c/new-construction-podlet-assets/feedback/rating-${rating}.svg`;
    };

    const feedbackIcons = [cdn('1'), cdn('2'), cdn('3'), cdn('4')];

    return (
        <S.FeedbackFace
            className="u-text-center grid__unit u-size1of4"
            desktop={isDesktop()}
        >
            <LinkButton onClick={() => onClick()} disabled={disabled}>
                <img
                    src={feedbackIcons[nr]}
                    alt={`Velg tilbakemelding: ${text}`}
                />
            </LinkButton>
            <p className="u-caption">{text}</p>
        </S.FeedbackFace>
    );
};

FeedbackFace.propTypes = {
    nr: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default FeedbackFace;
